document.addEventListener('DOMContentLoaded', function () {
    // Select the toggle button, minimize button, modal overlay, modal, webchat, and banner elements
    const toggleButton = document.getElementById('chat_toggle'),
        minimizeButton = document.getElementById('minimize_chat'), // The new minimize button
        chatModalOverlay = document.getElementById('chat_modal_overlay'),
        chatModal = document.getElementById('chat_modal'),
        webchat = document.getElementById('webchat'),
        chatBanner = document.querySelector('.chat-banner');

    // Function to toggle the 'active' class on the modal and overlay
    const toggleModal = function () {
        chatModal.classList.toggle('active');
        chatModalOverlay.classList.toggle('active');
    };

    // Listen for click events on both buttons
    toggleButton.addEventListener('click', toggleModal);
    minimizeButton.addEventListener('click', toggleModal);

    // Optional: Close the modal on clicking outside of it
    window.addEventListener('click', function (event) {
        if (event.target === chatModalOverlay) {
            chatModal.classList.remove('active');
            chatModalOverlay.classList.remove('active');
        }
    });

    // Function to calculate and set the height of the webchat
    const adjustWebchatHeight = function () {
        const chatModalHeight = chatModal.offsetHeight;
        const chatBannerHeight = chatBanner.offsetHeight;
        const newHeight = chatModalHeight - chatBannerHeight;

        // Set the new height for webchat
        webchat.style.height = `${newHeight}px`;
    };

    // Initial height adjustment
    adjustWebchatHeight();

    // Use ResizeObserver to watch for changes in the size of chatModal and chatBanner
    const resizeObserver = new ResizeObserver(() => {
        adjustWebchatHeight();
    });

    // Observe both chatModal and chatBanner for size changes
    resizeObserver.observe(chatModal);
    resizeObserver.observe(chatBanner);

    // Optional: Recalculate height when the window is resized (as an additional safety)
    window.addEventListener('resize', adjustWebchatHeight);

    console.log('Webchat height is being updated in real time');
});
